export default "__VITE_ASSET__DB1zGTH0__"